module.exports = __webpack_public_path__ + "static/media/mtn.50ca408b.svg";